import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import Loader from "../../../../components/ui/Loader";
import { useGetSingleBatchQuery } from "../../../../features/portal/batch/batchApi";
import { useGetSingleUserWalletRoleQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import PaidListTable from "./PaidListTable";
import PendingListTable from "./PendingListTable";

export default function PaymentsV2() {
  const roleCheck = localStorage.getItem("project_role");
  const { id, walletId } = useParams();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const numericWalletId =
    walletId === "null" || walletId === null ? undefined : Number(walletId);

  const {
    data: getSingleUserWalletRoleData,
    isError: getSingleUserWalletRoleIsError,
    error: getSingleUserWalletRoleError,
    isLoading: getSingleUserWalletRoleIsLoading,
  } = useGetSingleUserWalletRoleQuery(
    {
      walletId: numericWalletId,
      userId: user?.data?.id,
    },
    { skip: numericWalletId === undefined || !user?.data?.id }
  );

  const { data: singleBatchData } = useGetSingleBatchQuery(id);

  const singleBatch = singleBatchData?.data;

  useError(
    getSingleUserWalletRoleIsError,
    getSingleUserWalletRoleError,
    "Get single user wallet role failed"
  );

  // useEffect(() => {
  //   if (getSingleUserWalletRoleIsError) {
  //     setTimeout(() => {
  //       navigate("/admin/salary-disbursement/batch");
  //     }, 1500);
  //   }
  // }, [getSingleUserWalletRoleIsError, navigate]);

  console.log("walletId:", walletId);

  return (
    <SidebarLayout
      title={singleBatch?.batchName}
      backLink={`/admin/salary-disbursement/batch`}
    >
      {getSingleUserWalletRoleIsLoading ? (
        <Loader />
      ) : (
        <div>
          <div>
            <PendingListTable
              getSingleUserWalletRoleData={getSingleUserWalletRoleData}
            />
          </div>
          {getSingleUserWalletRoleData?.data?.role === "maker" &&
            roleCheck === "User" && (
              <div className="mt-[60px]">
                <PaidListTable
                  getSingleUserWalletRoleData={getSingleUserWalletRoleData}
                />
              </div>
            )}
        </div>
      )}
    </SidebarLayout>
  );
}
